import React, { Component } from 'react';
import PropTypes from 'prop-types'
import { translate } from 'react-i18next'
import compose from 'lodash.compose';

class Crc extends Component {
  state = {
    open: false
  };
  render() {
    const { t, crc, isOpened } = this.props;
    if (crc.length === 0) {
      return '';
    }
    const { open } = this.state;
    return (
      <>
        <h3
          onClick={() => this.setState({ open: !open })}
          style={{ cursor: 'pointer' }}
        >
          {open && <i className="fa fa-chevron-down" />}
          {!open && <i className="fa fa-chevron-right" />}
          {' '}
          {t('crc.title')}
        </h3>
        {(open || isOpened) && (
          <div className="table-wrapper">
            <div className="div-table">
              <div className="div-table-body">
                {crc.map(({ _id }) => (
                  <div className="div-table-row" key={_id}>
                    <div className="div-table-cell">{_id}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </>
    );
  }
}

Crc.defaultProps = {};
Crc.propTypes = {
  isOpened: PropTypes.bool,
  crc: PropTypes.arrayOf(
    PropTypes.shape({
      _id: PropTypes.string.isRequired,
    }),
  )
};

export default compose(
  translate('product'),
)(Crc);
